import { AddOnsProduct } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { readHasActiveOffering, readIsUsedInActivePackage } from "./productDtoHelpers";

export async function getAddOnById(divisionId: number, addOnId: string):Promise<AddOnsProduct|void> {
    const localApi = await getLocalApi();

    return await localApi.fetchSingle(apiConfig.addons_get_by_id.replace("{divisionId}", divisionId.toString()).replace("{addonId}", addOnId),
    mapAddOnProduct,
    "Failed to fetch addon product byId");
}

function mapAddOnProduct(addonProduct: any): AddOnsProduct {
    return {
        id: addonProduct.productId,
        name: addonProduct.productName,
        unitTypeText: addonProduct.unitTypeText,
        unitTypeId:addonProduct.unitTypeId,
        entityUpdate: addonProduct.entityUpdate,
        accountCategories: addonProduct.accountCategories,
        productCategories: addonProduct.productCategories,
        commissionCategories: addonProduct.commissionCategories,
        productCategoryId: addonProduct.productCategoryId,
        accountCategoryId: addonProduct.accountCategoryId,
        division: addonProduct.divisionId,
        typeId: addonProduct.typeId,
        typeText: addonProduct.typeText,
        active: addonProduct.active ?? true,
        minimumAge: addonProduct.minimumAge ?? null,
        excludedBookingSystemIds: Array.isArray(addonProduct.excludedBookingSystemIds)
          ? addonProduct.excludedBookingSystemIds.map((id: number | string) => String(id))
          : [],
        numberOfOneToOneLessonsPerWeek: addonProduct.numberOfOneToOneLessonsPerWeek,
        hasActiveOffering: readHasActiveOffering(addonProduct),
        isUsedInActivePackage: readIsUsedInActivePackage(addonProduct),
    }
}